"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const any_1 = require("../any");
/*
 * Pass each value in array to async callback function and reduce to one value.
 * Async version of Array.prototype.reduce.
 *
 *
 * @Param {Array} array       = The items to reduce.
 * @Param {Function} callback = The callback to use when reducing.
 * @Param {any}               = The default value to use.
 *
 * @Example
 *   reducePromises([1, 2, 3], async (acc, num) => {
 *     return acc + num
 *   }, 0)
 *   //=> 6
 */
function reducePromises(array, callback, defaultValue) {
    if (any_1.isMissing(defaultValue)) {
        const [firstItem, ...tail] = array;
        return reducePromises(tail, callback, firstItem);
    }
    // eslint-disable-next-line max-len
    return array.reduce((acc, ...args) => __awaiter(this, void 0, void 0, function* () { return acc.then((resolvedAcc) => callback(resolvedAcc, ...args)); }), Promise.resolve(defaultValue));
}
exports.reducePromises = reducePromises;
//# sourceMappingURL=reduce-promises.js.map